import Vue from 'vue';

Vue.filter('currency', (val: number | string) => {
	if (!val) return '';
	const value = typeof val === 'string' ? parseFloat(val) : val;
	const formatter = new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return formatter.format(value);
});


Vue.filter('year', (val: number) => {
	if (!val) return '';	
	return new Date(val).getFullYear();
});